import styled from 'styled-components';

type iconsProps = {
    color:string,
    isSelected:boolean
}

export const StyledMobileMenuICons = styled.a<iconsProps>`
    display: flex;
    flex-direction:column;
    align-items: center;
    position: relative;
    width: 30%;
    max-height: 54.58px;
    height: 100%;
    span {
        font-size: 8px;
        font-family: ${props => props.theme.fontfamily };
    }
    & svg{
      fill: ${props => props.isSelected ? props.color : "#8C8C91"};  
      width: 2rem;
      height: 2rem;
      /* ${({ isSelected,color }) => isSelected && `
        fill: 
        stroke: ${color}
     `} */
    }
    & span{
      ${({ isSelected,color }) => isSelected && `
        color: ${color}
     `}
    }
`

export const StyledContainerMobileMenu = styled.div`
    display: flex;
    justify-content: space-evenly;
    align-content: center;
    align-items: center;
    width: 100%;
`